import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { KlmrTimesheetCreatePage } from './klmr-timesheet-create';

@NgModule({
  declarations: [
    KlmrTimesheetCreatePage,
  ],
  imports: [
    IonicPageModule.forChild(KlmrTimesheetCreatePage),
  ],
})
export class KlmrTimesheetCreatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-create/klmr-timesheet-create.module.ts